import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { ModalConfirmationDeleteInputCodeService } from './service/modal-confirmation-delete-input-code.service';

import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NotificationsService } from '../../../../shared/components/notifications/service/notifications.service';
import { LoginService } from '../../../login/service/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'perfil-user-component-modal-confirmation-delete-input-code',
  imports: [ReactiveFormsModule],
  templateUrl: './modal-confirmation-delete-input-code.component.html',
  styleUrl: './modal-confirmation-delete-input-code.component.css'
})
export class ModalConfirmationDeleteInputCodeComponent {
  modalConfirmationDeleteInputCodeService = inject(ModalConfirmationDeleteInputCodeService);
  notificationsService = inject(NotificationsService);
  formBuilder = inject(NonNullableFormBuilder);
  LoginService = inject(LoginService);
  router=inject(Router);

  @ViewChild('code1') code1!: ElementRef;
  @ViewChild('code2') code2!: ElementRef;
  @ViewChild('code3') code3!: ElementRef;
  @ViewChild('code4') code4!: ElementRef;
  @ViewChild('code5') code5!: ElementRef;
  @ViewChild('code6') code6!: ElementRef;

  form: FormGroup = this.formBuilder.group({
    codeDelete: ['', Validators.required],
  });

  onCodeInput(event: any, currentInput: HTMLInputElement | null, nextInput: HTMLInputElement | null): void {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      return;
    }

    // Asegurarse de que solo se ingresen números
    const inputValue = event.target.value;
    if (!/^\d*$/.test(inputValue)) {
      event.target.value = inputValue.replace(/\D/g, '');
    }

    // Mover al siguiente input si existe
    if (inputValue && nextInput) {
      nextInput.focus();
    }

    // Actualizar el valor del formulario
    this.updateFormValue();
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;

    const pastedText = clipboardData.getData('text');
    const digits = pastedText.replace(/\D/g, '').substring(0, 6).split('');

    const inputs = [
      this.code1?.nativeElement,
      this.code2?.nativeElement,
      this.code3?.nativeElement,
      this.code4?.nativeElement,
      this.code5?.nativeElement,
      this.code6?.nativeElement
    ];

    digits.forEach((digit, index) => {
      if (inputs[index]) {
        inputs[index].value = digit;
      }
    });

    // Enfocar el siguiente campo vacío o el último si todos están llenos
    const nextEmptyIndex = inputs.findIndex(input => !input.value);
    if (nextEmptyIndex >= 0) {
      inputs[nextEmptyIndex].focus();
    } else if (inputs[5]) {
      inputs[5].focus();
    }

    this.updateFormValue();
  }

  updateFormValue(): void {
    if (!this.code1 || !this.code2 || !this.code3 || !this.code4 || !this.code5 || !this.code6) return;

    const code = [
      this.code1.nativeElement.value,
      this.code2.nativeElement.value,
      this.code3.nativeElement.value,
      this.code4.nativeElement.value,
      this.code5.nativeElement.value,
      this.code6.nativeElement.value
    ].join('');

    this.form.get('codeDelete')?.setValue(code);
  }

  onSubmit(): void {
    this.updateFormValue();

    if (this.form.valid && this.form.value.codeDelete.length === 6) {
      const codeDelete = this.form.value.codeDelete;
      // console.log(codeDelete);
      this.modalConfirmationDeleteInputCodeService.deleteAccount(codeDelete).subscribe({
        next: () => {
          this.notificationsService.addNotification(
            {
              message: 'Cuenta eliminada con éxito',
              type: 'success',
              duration: 3000
            }
          );
          this.modalConfirmationDeleteInputCodeService.closeModal();


          this.router.navigate(['/auth/login']);

        },
      });
    } else {
      this.notificationsService.addNotification({
        message: 'Por favor ingrese el código completo de 6 dígitos',
        type: 'error',
        duration: 3000
      });
    }
  }

  closeModal(): void {
    this.modalConfirmationDeleteInputCodeService.closeModal();
  }
  // deleteAccount(): void {
  //   this.modalConfirmationDeleteInputCode.deleteAccount().pipe()
  // }
}
